export type PeopleCompaniesDatabaseMetaInput = {
  databaseName: string;
  tab: string;
  /** Pagination / match count for the current list query. */
  listTotal: number;
  /** Full Database Entity count including Child Database Entities. */
  databaseTotalEntities: number | null | undefined;
  hasSearchOrFilters: boolean;
};

/**
 * Header meta for people & companies database detail.
 * Plain All tab shows full Database Entity count (and top-level when hierarchies exist).
 * Search, filters, and status tabs show the current list match count only.
 */
export function formatPeopleCompaniesDatabaseMeta(
  input: PeopleCompaniesDatabaseMetaInput,
): string {
  const {
    databaseName,
    tab,
    listTotal,
    databaseTotalEntities,
    hasSearchOrFilters,
  } = input;

  const isPlainAllTab =
    tab.toLowerCase() === 'all' && !hasSearchOrFilters;

  if (!isPlainAllTab) {
    return `${databaseName} Database • ${listTotal} entities`;
  }

  const total =
    databaseTotalEntities !== null && databaseTotalEntities !== undefined
      ? databaseTotalEntities
      : listTotal;

  if (total > listTotal) {
    return `${databaseName} Database • ${total} entities • ${listTotal} top-level`;
  }

  return `${databaseName} Database • ${total} entities`;
}
